import React, { useEffect, useRef, useState } from "react";
import { Badge } from "react-bootstrap";

declare const window: any;

const TooltipContainer = React.memo(
  ({
    colors,
    moneda,
    moneda_symbol,
    frame,
    isSelectedApto,
    setIsSelectedApto,
    theme,
    originalWidth,
    originalHeight,
    data,
    attributes,
    cotizacion,
    setGaleriaSelected,
    setOriginalGleriaSelected,
    subMenuSelected,
    setSubMenuSelected,
    selectedCotizacion,
    setSelectedCotizacion,
    setIsCotizacion,
    setIsSelectedAptoView,
  }: //setIsSideBar
  //active
  any) => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);

    // Inicializar la useRef con el valor inicial de `frame`
    const prevFrameRef = useRef(frame);

    useEffect(() => {
      // Calcular la posición proporcional del div en el viewport
      const posX = (isSelectedApto?.verts[0][0] / originalWidth) * screenWidth;
      const posY =
        (isSelectedApto?.verts[0][1] / originalHeight) * screenHeight;

      /* animation-name: swipe-show-hotspots
    animation-duration: 0.5s
    transform-origin: bottom
    opacity: 1 */

      // Colocar el div en la posición calculada
      const targetDiv: any = document.getElementById("tooltip-container");
      targetDiv.style.left =
        !window.functionIsPortrait() && window.functionIsMobileDevice()
          ? `${posX + 210 > screenWidth ? posX - 210 : posX + 50}px`
          : window.functionIsPortrait() && window.functionIsMobileDevice()
          ? `${posX + 200 > screenWidth ? posX - 200 : posX + 20}px`
          : `${posX + 420 > screenWidth ? posX - 420 : posX + 100}px`;

      targetDiv.style.top =
        !window.functionIsPortrait() && window.functionIsMobileDevice()
          ? `${posY - 165 >= 0 ? posY - 165 : 5}px`
          : `${posY - 195}px`;
      // ====== AJUSTE FINAL PARA GARANTIZAR QUE NO SE SALGA ======
      const rect = targetDiv.getBoundingClientRect();

      /* if (rect.left < 0) targetDiv.style.left = "5px";
      if (rect.right > screenWidth)
        targetDiv.style.left = `${screenWidth - rect.width - 5}px`; */

      if (rect.top < 0) targetDiv.style.top = "5px";
      if (rect.bottom > screenHeight)
        targetDiv.style.top = `${screenHeight - rect.height - 5}px`;
      
      targetDiv.classList.add("tooltip-animation");

      setTimeout(() => {
        targetDiv.classList.remove("tooltip-animation");
      }, 501);
    }, [isSelectedApto, screenWidth, screenHeight]);

    useEffect(() => {
      if (JSON.stringify(prevFrameRef.current) !== JSON.stringify(frame)) {
        console.log(frame);
        setIsSelectedApto({});

        // Actualiza la referencia al frame actual para la próxima comparación
        prevFrameRef.current = frame;
      }
    }, [frame]);

    function capitalizeWords(str: string): string {
      return str.toLowerCase().replace(/(^\w|\s\w)/g, (c) => c.toUpperCase());
    }

    //console.log(isSelectedApto);

    return (
      <div id="tooltip-container" className={`tooltip-container ${theme}`}>
        <div className="tooltip-container-header">
          <div>
            {data?.model !== "TORRES"
              ? data?.model
                  .toLowerCase() // todo en minúsculas
                  .split(" ") // dividir en palabras
                  .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ")
              : "Inmueble"}{" "}
            {isSelectedApto?.property}
            {data?.properties?.disponibilidad && (
              <Badge
                pill
                bg={
                  isSelectedApto?.availability === "DISPONIBLE"
                    ? "success"
                    : isSelectedApto?.availability === "RESERVADO"
                    ? "warning"
                    : isSelectedApto?.availability === "VENDIDO"
                    ? "danger"
                    : isSelectedApto?.availability === "NO DISPONIBLE"
                    ? "dark"
                    : "success"
                }
                className="ms-2"
              >
                {capitalizeWords(isSelectedApto?.availability)}
              </Badge>
            )}
          </div>
          <div
            className="setting-boton-circular">
            <i
              className="fas fa-xmark"
              onClick={() => setIsSelectedApto({})}
            ></i>
          </div>
        </div>
        <div className="tooltip-container-jerarquia">
          {
            isSelectedApto?.values?.find(
              (e: any) => e.hierarchicalLevel === "Jerarquico #2"
            )?.value
          }
          {isSelectedApto?.values?.find(
            (e: any) => e.hierarchicalLevel === "Jerarquico #2"
          ) !== undefined
            ? "  /  "
            : null}
          {
            isSelectedApto?.values?.find(
              (e: any) => e.hierarchicalLevel === "Jerarquico #1"
            )?.value
          }
        </div>
        <div className="tooltip-container-attributes">
          {isSelectedApto?.values
            ?.sort((a: any, b: any) => a.indice - b.indice)
            .map((e: any) => {
              if (e.type !== "Hierarchical" && e.state_attribute) {
                return (
                  <div className="tooltip-container-attributes-row">
                    <div>
                      {attributes?.find((a: any) => a.id === e.attribute).name}:{" "}
                      {e.value === "0 m²" || e.value === "0"
                        ? " N/A "
                        : e.value}
                    </div>
                    {/* <div>{e.value}</div> */}
                  </div>
                );
              }
            })}

          {isSelectedApto.price > 0 ? (
            <div className="tooltip-container-attributes-row">
              <div>Precio</div>
              <div>
                {new Intl.NumberFormat(moneda, {
                  style: "currency",
                  currency: moneda_symbol,
                }).format(isSelectedApto.price)}{" "}
                {moneda_symbol}
              </div>
            </div>
          ) : null}
          {isSelectedApto?.galleries?.length > 0 &&
          isSelectedApto?.galleries?.filter(
            (g: any) => g.name !== "Vistadeinmuebles"
          )?.length > 0 ? (
            <div
              className="tooltip-container-attributes-button-gallery"
              onClick={() => {
                setGaleriaSelected(isSelectedApto?.galleries),
                  setSubMenuSelected("Galería"),
                  setOriginalGleriaSelected(isSelectedApto?.galleries);
              }}
            >
              <i className={`fa-regular fa-images`}></i>
              Ver galería
            </div>
          ) : null}
          {isSelectedApto?.galleries?.length > 0 &&
          isSelectedApto?.galleries?.filter(
            (g: any) => g.name === "Vistadeinmuebles"
          )?.length > 0 /* && screenWidth > screenHeight */ ? (
            <div
              className="tooltip-container-attributes-button-gallery"
              style={{ marginTop: "0.625rem" }}
              onClick={() => {
                setIsSelectedAptoView(isSelectedApto);
                //setIsSideBar(false);
                //setSubMenuSelected("Torre 1")
              }}
            >
              <img
                src="./UI/general/PDI_white.svg"
                style={{
                  aspectRatio: "1",
                  height: "50%",
                  marginRight: "0.625rem",
                }}
                alt=""
              />
              Ver vista
            </div>
          ) : null}
          {/* {isSelectedApto && data.type_product === "3D" ? (
            <div
              className="tooltip-container-attributes-button-gallery"
              style={{ marginTop: "0.625rem" }}
              onClick={() => {
                setIsSelectedAptoView(isSelectedApto);
                //setSubMenuSelected("Torre 1")
              }}
            >
              <img
                src="./UI/general/PDI_white.svg"
                style={{
                  aspectRatio: "1",
                  height: "50%",
                  marginRight: "0.625rem",
                }}
                alt=""
              />
              Ver vista
            </div>
          ) : null} */}
          {isSelectedApto?.spins?.length > 0 ? (
            <div
              className="tooltip-container-attributes-button-spin"
              onClick={() => {
                //setGaleriaSelected(isSelectedApto?.galleries),
                setSubMenuSelected(isSelectedApto?.id);
                //setOriginalGleriaSelected(isSelectedApto?.galleries);
              }}
            >
              <i className={`fa-solid fa-panorama`}></i>
              Spin
            </div>
          ) : null}
        </div>
        {cotizacion ? (
          <div
            className={`tooltip-container-button-cotizacion ${
              selectedCotizacion?.length >= 5 ? "disabled" : ""
            }`}
            style={
              selectedCotizacion?.find(
                (e: any) => JSON.stringify(e) === JSON.stringify(isSelectedApto)
              )
                ? { color: "#FFF", backgroundColor: colors?.main_buttons }
                : {}
            }
            onClick={() => {
              if (
                selectedCotizacion?.find(
                  (e: any) =>
                    JSON.stringify(e) === JSON.stringify(isSelectedApto)
                )
              ) {
                // Si el objeto ya está en el array, lo eliminamos
                setSelectedCotizacion((prev: any) =>
                  prev.filter(
                    (e: any) =>
                      JSON.stringify(e) !== JSON.stringify(isSelectedApto)
                  )
                );
              } else {
                // Si el objeto no está en el array y no está deshabilitado, lo agregamos
                if (selectedCotizacion?.length < 5) {
                  setSelectedCotizacion((prev: any) => [...prev, isSelectedApto]);
                }
              }
              setIsCotizacion(true);
            }}
          >
            {selectedCotizacion?.find(
              (e: any) => JSON.stringify(e) === JSON.stringify(isSelectedApto)
            )
              ? "Agregado a cotización"
              : "Agregar a cotización"}
          </div>
        ) : null}

        {cotizacion && selectedCotizacion?.length >= 5 ? (
          <div className="tooltip-container-label-cotizacion">
            Has seleccionado el máximo de inmuebles. Ve a{" "}
            <strong>Cotiza</strong> para gestionar los inmuebles seleccionados.
          </div>
        ) : null}
      </div>
    );
  }
);

export default TooltipContainer;
